import { useTheme } from '@fluentui/react';
import { IStackStyles, Stack } from '@fluentui/react/lib/Stack';
import { mergeStyles } from '@fluentui/react/lib/Styling';
import React from 'react';
import { messageStyles } from './MessageStyles';

/**
 * @param text: text to be displayed in the message
 */
export type MessageProps = {
  text: string | JSX.Element;
  logo?: string;
  messageType?: 'remote' | 'user';
};

const logoStackStyle: IStackStyles = {
  root: {
    alignItems: 'center',
    justifyContent: 'center',
  },
};

/**
 *
 * Component for displaying message, used as base components in other components
 *
 */
const Message = ({ messageType, text, logo }: MessageProps): JSX.Element => {
  const theme = useTheme();
  const styles = messageStyles(theme);

  if (messageType == 'remote') {
    return (
      <Stack
        horizontal
        styles={styles.remoteMessage}
        tokens={{ childrenGap: 10 }}
      >
        {logo && (
          <Stack styles={logoStackStyle}>
            <img style={{ maxHeight: '2rem' }} src={logo} />
          </Stack>
        )}
        <Stack verticalAlign="center">
          <div className={mergeStyles(styles.remoteText)}>{text}</div>
        </Stack>
      </Stack>
    );
  } else {
    return (
      <Stack
        horizontal
        horizontalAlign='center'
        styles={styles.userMessage}
        tokens={{ childrenGap: 10 }}
      >
        <Stack>
          <div className={mergeStyles(styles.userText)}>{text}</div>
        </Stack>
      </Stack>
    );
  }
};

export { Message };
